import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import { bindActionCreators } from "redux";
import Select from 'react-select';
import moment from 'moment';
import { ButtonToolbar, ToggleButtonGroup, ToggleButton } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faThLarge,
  faList,
  // faPlus
} from "@fortawesome/free-solid-svg-icons";
import HistoryCard from "../../components/dashboard/HistoryCard";
import WishCard from "../../components/wishlist/WishCard";
import { addWishDetail } from "../../actions/wishs";
import OkLogo from "../../assets/images/ok_logo.png";
import "./Wishlist.scss";

const orderOptions = [
  { value: 1, label: 'Most upvoted' },
  { value: 2, label: 'Created Date(ASC)' },
  { value: 3, label: 'Created Date(DESC)' },
];

const selectStyles = (width) => {
  return {
    control: styles => ({
      ...styles,
      backgroundColor: 'white',
      minWidth: width,
      height: 32,
      minHeight: 20,
      marginRight: 10
    }),
  }
};

class Wishlist extends Component {
  constructor(props) {
    super(props);

    this.state = {
      orderType: null
    };
  }

  componentDidMount () {
    // From willMount
    const isAdmin = _.get(this.props, "cognitoUser.attributes['custom:role']") === 'admin';

    if (!isAdmin) {
      this.props.history.push('/dashboard');
    }
    //////
  }

  handleGridChange = (value) => {
  }

  gotoWishDetail = (id) => {
    this.props.addWishDetail(id);
    this.props.history.push(`/wish/detail/${id}`);
  }

  handleOrderChange = value => {
    this.setState({ orderType: value ? value.value : null });
  }

  orderWishs = () => {
    const { orderType } = this.state;
    const { wishs } = this.props;

    switch (orderType) {
      case 1:
        return wishs.sort((w1, w2) => {
          const c1 = _.get(w1, 'upvoteCount', 0);
          const c2 = _.get(w2, 'upvoteCount', 0);
          if (c1 < c2) {
            return 1;
          } else if (c1 === c2) {
            return 0;
          } else {
            return -1;
          }
        });
      case 2:
        return wishs.sort((w1, w2) => {
          if (moment(w1.createdAt) < moment(w2.createdAt)) {
            return 1;
          } else if (moment(w1.createdAt) === moment(w2.createdAt)) {
            return 0;
          } else {
            return -1;
          }
        });
      case 3:
        return wishs.sort((w1, w2) => {
          if (moment(w1.createdAt) > moment(w2.createdAt)) {
            return 1;
          } else if (moment(w1.createdAt) === moment(w2.createdAt)) {
            return 0;
          } else {
            return -1;
          }
        });
      default:
        return wishs;
    }
  }

  render() {
    // const isAdmin = _.get(this.props, "cognitoUser.attributes['custom:role']") === 'admin';
    const { orderType } = this.state;
    const orderedWishs = this.orderWishs();

    return (
      <div className="wishlist-container">
        <div className="filter-sidebar">
        </div>
        <div className="content-wrapper">
          <div className="sort-bar">
            <span>Team Wishlist</span>
            <div className="sort-actions">
              <Select
                options={orderOptions}
                placeholder="Order By"
                isClearable={true}
                value={orderType ? { value: orderType, label: orderOptions.find(or => or.value === orderType).label } : null}
                styles={selectStyles(220)}
                onChange={this.handleOrderChange}
              />
              <ButtonToolbar>
                <ToggleButtonGroup type="radio" name="options" defaultValue={0} onChange={this.handleGridChange}>
                  <ToggleButton value={0} size="sm"><FontAwesomeIcon icon={faThLarge} /></ToggleButton>
                  <ToggleButton value={1} size="sm"><FontAwesomeIcon icon={faList} /></ToggleButton>
                </ToggleButtonGroup>
              </ButtonToolbar>
            </div>
          </div>
          <div className="cards-container">
            {orderedWishs.map(wish => <WishCard onClick={this.gotoWishDetail} wish={wish} key={wish.id} />)}
          </div>
        </div>
        <div className="recent-history-wrapper">
          <div className="history-title"><h3>Recent Activity</h3></div>
          <HistoryCard activities={this.props.activities} />
          <div className="bottom-logo">
            <img src={OkLogo} alt="bottom logo" />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  cognitoUser: state.auth.cognitoUser,
  activities: state.activity.activities || [],
  wishs: state.wishlist.wishs
});

const mapDispatchToProps = dispatch => 
bindActionCreators({
  addWishDetail
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Wishlist);
